// action
export const getSelling = (state, val) => {
  state.sellings = val
}

export const listSelling = (state, temp) => {
  state.lists = temp
}

export const sellingForm = (state, val) => {
  state.selling = val
}
